// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { listStyles } from "@insite/content-library/Widgets/Brand/BrandGallery";
import { xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

listStyles.titleText = {
    variant: "h2",
};

listStyles.imageContainer = {
    css: css`
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(167px, 1fr));
        column-gap: 22px;
        row-gap: 84px;
        ${xScreen("lte", "md")} {
            grid-template-columns: repeat(auto-fit, minmax(106px, 1fr));
            column-gap: 20px;
            row-gap: 40px;
        }
        ${xScreen("lte", "xs")} {
            grid-template-columns: repeat(auto-fit, minmax(99px, 1fr));
            column-gap: 15px;
            row-gap: 24px;
        }
    `,
};

listStyles.imageItem = {
    css: css`
        display: flex;
        justify-content: flex-start;
        align-items: center;

        width: 204px;
        height: 204px;

        ${xScreen("lte", "md")} {
            width: 106px;
            height: 106px;
        }
        ${xScreen("lte", "xs")} {
            height: 99px;
            width: 99px;
        }
    `,
};

listStyles.image = {
    height: "100px",
    width: "167px",
    css: css`
        ${xScreen("lte", "md")} {
            height: 106px;
            width: 106px;
        }
        ${xScreen("lte", "xs")} {
            height: 99px;
            width: 99px;
        }
        img {
            aspect-ratio: 5/3;
        }
    `,
};
